import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useExpenseSubCategory, ExpenseSubCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ExpenseSubCategory>
      useData={useExpenseSubCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

